// deps
import React, { memo } from "react";

// styles
import { CardContainer, GlobalStyle, SectionHeader, StyledText } from "./styles";

// components
import CouponAppliedContainer from "./CouponAppliedContainer";
import ApplyCouponContainer from "./ApplyCouponContainer";

//constants
import { COUPON_HEADER, OFFER_HEADER } from "@dineout-cart-ui/constants/index";

export interface ICouponSectionProps {
    subtitle?: string;
    subtitleColour?: string;
    subtitleLogo?: string;
    title?: string;
    appliedCoupon?: string;
    appliedCouponValue?: number;
    onClickApplyCoupon: VoidFunction;
    onClickRemoveCoupon: VoidFunction;
}

export const CouponSection: React.FC<ICouponSectionProps> = (props: ICouponSectionProps) => {
    const {
        subtitle,
        subtitleLogo,
        appliedCoupon,
        subtitleColour,
        appliedCouponValue = 0,
        onClickApplyCoupon,
        onClickRemoveCoupon,
        title,
    } = props;
    const isCouponApplied = appliedCoupon && appliedCouponValue > 0;

    return (
        <div>
            <GlobalStyle />
            <SectionHeader>
                <StyledText variant="V2.body1.neutral.bold" color="text_High_Emphasis" data-testid={COUPON_HEADER}>
                    {OFFER_HEADER}
                </StyledText>
            </SectionHeader>
            {isCouponApplied ? (
                <CardContainer>
                    <CouponAppliedContainer
                        subtitle={subtitle}
                        title={title}
                        appliedCoupon={appliedCoupon}
                        onClickRemoveCoupon={onClickRemoveCoupon}
                    ></CouponAppliedContainer>
                </CardContainer>
            ) : (
                <CardContainer>
                    <ApplyCouponContainer
                        subtitle={subtitle}
                        subtitleLogo={subtitleLogo}
                        subtitleColour={subtitleColour}
                        onClickApplyCoupon={onClickApplyCoupon}
                    ></ApplyCouponContainer>
                </CardContainer>
            )}
        </div>
    );
};

export default memo(CouponSection);
